import React, {useContext} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// Import the heatmap module
import heatmap from 'highcharts/modules/heatmap';
import {COLORS, TEXT_REPORT_CAL, TYPE_THEME} from "../Constants/Const";
import {AuthContext} from "../Global/AuthContext";
// Initialize the heatmap module
heatmap(Highcharts);

// Load additional modules if needed
require('highcharts/modules/exporting')(Highcharts);



const data = [
      {
            date: '2023-07-01',
            total: 19.1
      },
      {
            date: '2023-07-02',
            total: 15.3
      },
      {
            date: '2023-07-03',
            total: 16.4
      },
      {
            date: '2023-07-04',
            total: 16.0
      },
      {
            date: '2023-07-05',
            total: 17.9
      },
      {
            date: '2023-07-06',
            total: 15.8
      },
      {
            date: '2023-07-07',
            total: 21.1
      },
      {
            date: '2023-07-08',
            total: 23
      },
      {
            date: '2023-07-09',
            total: 24
      },
      {
            date: '2023-07-10',
            total: 25
      },
      {
            date: '2023-07-11',
            total: 30
      },
      {
            date: '2023-07-12',
            total: 41
      },
      {
            date: '2023-07-13',
            total: 19
      },
      {
            date: '2023-07-14',
            total: 20
      },
      {
            date: '2023-07-15',
            total: 15
      },
      {
            date: '2023-07-16',
            total: 36
      },
      {
            date: '2023-07-17',
            total: 40
      },
      {
            date: '2023-07-18',
            total: 20
      },
      {
            date: '2023-07-19',
            total: 18
      },
      {
            date: '2023-07-20',
            total: 47
      },
      {
            date: '2023-07-21',
            total: 31
      },
      {
            date: '2023-07-22',
            total: 14
      },
      {
            date: '2023-07-23',
            total: 37
      },
      {
            date: '2023-07-24',
            total: 41
      },
      {
            date: '2023-07-25',
            total: 17
      },
      {
            date: '2023-07-26',
            total: 17
      },
      {
            date: '2023-07-27',
            total: 18
      },
      {
            date: '2023-07-28',
            total: 18
      },
      {
            date: '2023-07-29',
            total: 20
      },
      {
            date: '2023-07-30',
            total: 16
      },
      {
            date: '2023-07-31',
            total: 31
      }
];

const weekdays = ['DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB'];

function generateChartData(data) {

      // Calculate the starting weekday index (0-6 of the first date in the given
      // array)
      const firstWeekday = new Date(data[0].date).getDay(),
          monthLength = data.length,
          lastElement = data[monthLength - 1].date,
          lastWeekday = new Date(lastElement).getDay(),
          lengthOfWeek = 6,
          emptyTilesFirst = firstWeekday,
          chartData = [];
  
      // Add the empty tiles before the first day of the month with null values to
      // take up space in the chart
      for (let emptyDay = 0; emptyDay < emptyTilesFirst; emptyDay++) {
          chartData.push({
              x: emptyDay,
              y: 5,
              value: null,
              date: null,
              custom: {
                  empty: true
              }
          });
      }
  
      // Loop through and populate with temperature and dates from the dataset
      for (let day = 1; day <= monthLength; day++) {
          // Get date from the given data array
          const date = data[day - 1].date;
          // Offset by thenumber of empty tiles
          const xCoordinate = (emptyTilesFirst + day - 1) % 7;
          const yCoordinate = Math.floor((firstWeekday + day - 1) / 7);
          const id = day;
  
          // Get the corresponding temperature for the current day from the given
          // array
          const temperature = data[day - 1].total;
  
          chartData.push({
              x: xCoordinate,
              y: 5 - yCoordinate,
              value: temperature,
              date: new Date(date).getTime(),
              custom: {
                  monthDay: id
              }
          });
      }
  
      // Fill in the missing values when dataset is looped through.
      const emptyTilesLast = lengthOfWeek - lastWeekday;
      for (let emptyDay = 1; emptyDay <= emptyTilesLast; emptyDay++) {
          chartData.push({
              x: (lastWeekday + emptyDay) % 7,
              y: 0,
              value: null,
              date: null,
              custom: {
                  empty: true
              }
          });
      }
      return chartData;
}

export function CalendarMechanical(){

      const { theme } = useContext(AuthContext);

      const isLigth = theme.MUI === TYPE_THEME.light;

        // Chart options
      const options = {
            
            chart: {
                  type: 'heatmap',
                  height: 500,
                  backgroundColor: isLigth? COLORS.black:null,
            },
        
            title: {
                  text: TEXT_REPORT_CAL.title,
                  align: 'left',
                  style:{
                        color: isLigth? COLORS.ligth.title:COLORS.dark.title
                  }
            },
        
            subtitle: {
                  text: TEXT_REPORT_CAL.subtitle,
                  align: 'left',
                  style:{
                        color: isLigth? COLORS.ligth.subtitle:COLORS.dark.subtitle
                  }
            },
        
            accessibility: {
                  landmarkVerbosity: 'one',
                  enabled: false,
            },
        
            tooltip: {
                  enabled: true,
                  outside: true,
                  zIndex: 20,
                  headerFormat: '',
                  pointFormat: '{#unless point.custom.empty}{point.date:%A, %b %e, %Y}{/unless}',
                  nullFormat: 'No data'
            },
        
            xAxis: {
                  categories: weekdays,
                  opposite: true,
                  lineWidth: 26,
                  offset: 13,
                  lineColor: isLigth? COLORS.black:COLORS.whiteisLigth? COLORS.black:COLORS.white,
                  labels: {
                        rotation: 0,
                        y: 20,
                        style: {
                              color: isLigth? COLORS.white:COLORS.black,
                              textTransform: 'uppercase',
                              fontWeight: 'bold'
                        }
                  },
                  accessibility: {
                        description: 'weekdays',
                        rangeDescription: 'X Axis is showing all 7 days of the week, starting with Sunday.'
                  }
            },
        
            yAxis: {
                  min: 0,
                  max: 5,
                  accessibility: {
                        description: 'weeks'
                  },
                  visible: false
            },
        
            legend: {
                  align: 'right',
                  layout: 'vertical',
                  verticalAlign: 'middle'
            },
        
            colorAxis: {
                  min: 0,
                  stops: [
                        [0.2, COLORS.lightblue],
                        [0.4, COLORS.green],
                        [0.6, COLORS.yellow],
                        [0.9, COLORS.red]
                  ],
                  labels: {
                        format: '{value} Unidad',
                        style: {
                              color: !isLigth? COLORS.black:COLORS.white
                        }
                  }
            },
        
            series: [
                  {
                        keys: ['x', 'y', 'value', 'date', 'id'],
                        data: generateChartData(data),
                        nullColor: 'rgba(196, 196, 196, 0.2)',
                        borderWidth: 2,
                        borderColor: 'rgba(196, 196, 196, 0.2)',
                        dataLabels: [{
                              enabled: true,
                              format: '{#unless point.custom.empty}{point.value:.0f}{/unless}',
                              style: {
                                    textOutline: 'none',
                                    fontWeight: 'normal',
                                    fontSize: '1rem'
                              }
                        }, {
                              enabled: true,
                              align: 'left',
                              verticalAlign: 'top',
                              format: '{#unless point.custom.empty}{point.custom.monthDay}{/unless}',
                              backgroundColor: 'whitesmoke',
                              padding: 2,
                              style: {
                                    textOutline: 'none',
                                    color: 'rgba(70, 70, 92, 1)',
                                    fontSize: '0.8rem',
                                    fontWeight: 'bold',
                                    opacity: 0.5
                              },
                              x: 1,
                              y: 1
                        }]
                  }
            ],

            credits: {
                  enabled: false
            },
      }
      
      return <HighchartsReact highcharts={Highcharts} options={options} />;
}